import React from 'react';
import '../../styles/ServiceSections.css';
import ContactButton from '../ContactButton';

interface ServiceHeaderProps {
  icon: string;
  heading: string;
  subheading: string;
  description: string;
  category: string;
  features?: string[];
  buttonLinks?: {
    primary: { text: string; url: string };
    secondary?: { text: string; url: string };
  };
  leftImage?: string;
  rightImage?: string;
}

const ServiceHeader: React.FC<ServiceHeaderProps> = ({
  icon = '/assets/services/circle.svg',
  heading,
  subheading,
  description,
  category,
  features,
  buttonLinks = {
    primary: { text: 'Get Started', url: '/contact' },
    secondary: { text: 'Schedule Consultation', url: '/contact' }
  },
  leftImage,
  rightImage,
}) => {
  // Determine text length class for responsive sizing
  const getCategoryClass = (text: string) => {
    if (text.length > 12) return 'very-long-text';
    if (text.length > 8) return 'long-text';
    return '';
  };

  return (
    <>
      <div className="service-header">
        <div className="service-header-left">
            <img src={icon} alt={`${category} icon`} className="finance-icon" />
        </div>
        <div className='service-header-content'>
          <h1 className='page-header-f-heading'>{heading}</h1>
          <div className='service-header-category-f'><p>{category}</p></div>
        </div>
        <div className="service-header-category">
          <span className={getCategoryClass(category)}>{category}</span>
        </div>
      </div>

      {/* Enterprise Section - Updated to match second image */}
      <div className="service-enterprise-section">
        <div className="enterprise-container">
          <div className="enterprise-content">
            <div className="enterprise-text enterprise-column">
              <h2 className="enterprise-title">{subheading}</h2>
              <p className="enterprise-description">{description}</p>
              
              <div className="enterprise-buttons">
                <ContactButton to={buttonLinks.primary.url} variant="fill">{buttonLinks.primary.text}</ContactButton>
                {buttonLinks.secondary && (
                  <ContactButton to={buttonLinks.secondary.url} variant="border">{buttonLinks.secondary.text}</ContactButton>
                )}
              </div>
            </div>

            <div className="enterprise-features enterprise-column">
              {features?.map((feature, index) => (
                <div key={index} className="feature-circle-item">
                  <div className="feature-circle">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <span className="feature-circle-text">{feature}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="enterprise-images-container">
            <div className="enterprise-image left-image">
              <img src={leftImage} alt="Left alt" />
            </div>
            <div className="enterprise-image right-image">
              <img src={rightImage} alt="Right alt" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ServiceHeader;